import { Component, OnInit, HostListener } from '@angular/core';
import { CustomService } from '../../services/custom.service';
import { AppManagementService } from '../../services/app-management.service';
import { AppTexts, ScreenNames } from '../../objects/app-static-texts';

@Component({
  selector: 'app-selfie-result',
  templateUrl: './selfie-result.component.html',
  styleUrls: ['./selfie-result.component.scss']
})
export class SelfieResultComponent implements OnInit {
  selfieResult :any;
  pageDesignFlag: boolean =false;
  pageDesign: any;
  clickedBtn: any;
  fileData: File = null;
  previewUrl: any = null;
  
  // FLAG FOR VIEW SWITCH BETWEEN CUSTOM AND TEMPLATE DESIGN
  customDesign:boolean = false;

  // VARIABLE FOR STORING CUSTOM CODE STRING
  htmlText: any;

  constructor(
    public appDesignService: AppManagementService,
    public customService: CustomService
  ) { 
    appDesignService.setBackClick(true);
  }

  ngOnInit() {
    this.pageDesign = this.appDesignService.getPageDesign();
    
    if(this.pageDesign!=undefined){
      this.pageDesignFlag = true;
      this.selfieResult = this.customService.getSelfieResult(); 
      //RESETTING SURVEY STARTED STATUS
      this.customService.surveyStarted = false;

      //SENDING PAGE VIEW FOR GA
      this.customService.sendPageViewUpdate(this.pageDesign.name);
      this.pageDesign["style"] = this.appDesignService.applyElementStyle(this.pageDesign);
      this.appDesignService.addToScreenHistory(this.pageDesign.name,"page");
      
      //IF PAGE DESIGN HAVE CUSTOM CODE
      if(this.pageDesign.custom_code !=undefined){
          
        //DECODE BASE64 CUSTOM CODE TO STRING
        this.htmlText = atob(this.pageDesign.custom_code);
        this.customDesign = true;
        var start=0;
        var end=0;
        for(let i = 0; i < this.htmlText.length; i++){
          if(this.htmlText[i]+""+this.htmlText[i+1] == "{{") { start = i+2 }
          if(this.htmlText[i]+""+this.htmlText[i+1] == "}}") { end = i; }
          
          if(start-end<0){
            var c = this.htmlText.substring(start,end);
            var value = '';  
            for(var e=0;e<this.pageDesign.element_flow.length;e++){
              if(this.pageDesign.element_flow[e].element_keyname == c){
                switch(this.pageDesign.element_flow[e].element_keyname) {
                  case 'screen_image_1':
                    value = this.customService.imageUrl;
                    break;
                  default:
                    value = this.pageDesign.element_flow[e].text;
                }
              }
            }
            this.htmlText = this.htmlText.replace("{{"+c+"}}",value);
            start = end = 0;
          }
        }
      }
      
      // ADDED FOR HOST PLATFORM MESSAGING
      if(!this.appDesignService.isMobile) { this.appDesignService.sentPostMessageToParent("normalContainer"); }

      //NORMAL ELEMENT FLOWS STACK LIST
      if(this.pageDesign.element_flow!=undefined){      
        // ADDING STYLE TO EACH ELEMENT IN THE PAGE
        for (var t = 0; t < this.pageDesign.element_flow.length; t++) {
          if(this.pageDesign.element_flow[t]["i18n_key"]==undefined){
            this.pageDesign.element_flow[t]["i18n_key"] = '';
          }
          if(this.pageDesign.element_flow[t].type == 'custom'){
            this.pageDesign.element_flow[t].custom_html = atob(this.pageDesign.element_flow[t].custom_code);
          }
          else{
            this.pageDesign.element_flow[t]["style"] = this.appDesignService.applyElementStyle(this.pageDesign.element_flow[t]);
          }
        }
      } 
      
      // SENDING IFRAME HEIGHT REFRESH PING TO IFRAME
      // // this.appDesignService.scrollToTop();
      setTimeout(() => { this.updateIframeHeight(); }, 300);
      this.captureImageLoadEvent();      
    } 
    else{
      this.appDesignService.redirectAppToBase();
    }
  }

  captureImageLoadEvent(){
    var imgs = document.querySelectorAll('img')
    for(var im=0;im<imgs.length;im++){
      if (imgs[im].complete) {
        this.updateIframeHeight()
      } else {
        imgs[im].addEventListener('load', this.updateIframeHeight)
        imgs[im].addEventListener('error', function() { })
      }
    } 
  }
  
  @HostListener('click', ['$event'])
  onClick(event: any) {    
    if(this.pageDesign.custom_code_enabled){
      if(event.target.name == 'back_button') { this.loadPrevious(); }
      for(var e=0;e<this.pageDesign.element_flow.length;e++){
        if(this.pageDesign.element_flow[e].element_keyname == event.target.id){
          this.customService.triggerFunction(this.pageDesign.element_flow[e]);
          this.updateIframeHeight();
        }
      }
    }
  }
  
  loadPrevious(){
    // Removed Current screen from history list
    this.appDesignService.popFromScreenHistory();

    // CHECK IF SURVEY HAS ALREADY STARTED
    var flag= this.customService.isSurveyContinued();
    
    var selected_queries = this.customService.getSelectedQueries();
    if(selected_queries!=undefined){
      if(selected_queries.length<1) { flag = false; }
    } else {
      flag = false;
    }

    if(flag){
      var selectedOptions = this.customService.getSelectedQueries();
      var remOp = selectedOptions[selectedOptions.length-1];
      if(remOp.type == AppTexts.screen && remOp.screen_name == ScreenNames.selfie){
        selectedOptions.pop();
        this.customService.saveSelectedQueries(selectedOptions);
      }
      this.customService.setBackButtonClicked(true);
      this.customService.loadSurveyScreen();
    } else {
      this.appDesignService.loadPrevious();
    }
  }

  ngAfterViewChecked() { this.updateIframeHeight(); }
  
  ngDoCheck() { this.updateIframeHeight(); }

  ngAfterContentChecked() { this.updateIframeHeight(); }

  updateIframeHeight() {
    if(this.pageDesign!=undefined){
      var ele = document.getElementById(this.pageDesign.name);
      if(ele!=null && ele!=undefined){
        var offsetHeight = ele.offsetHeight+70;
        if(this.appDesignService.isMobile) { offsetHeight = offsetHeight +100; }
        this.appDesignService.sentHeight(offsetHeight);
      }
    }
  }
}
